import { ReactNode } from "react";
import { Redirect } from "wouter";
import { useAuth } from "@/hooks/use-auth";

interface SalesOnlyRouteProps {
  children: ReactNode;
}

export function SalesOnlyRoute({ children }: SalesOnlyRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (user && user.role !== "admin" && user.role !== "sales_person") {
    return <Redirect to="/unauthorized" />;
  }

  return <>{children}</>;
}
